import React, { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";

import { alphabetAndNumberNoSpace, useBackgroundAssets } from "helper";
import { post_redeem_code, translate } from "redux/actions/main";
import { toggle_popup } from "redux/actions/modal";

export const Share = () => {
  const dispatch = useDispatch();
  const { info, is_share_finished } = useSelector((state) => state.main);
  const [isCopied, setIsCopied] = useState(false);
  const [code, setCode] = useState("");
  const t = (key) => dispatch(translate(key));

  const btnShareBg = useBackgroundAssets("btn_share");

  const handleRedeemInput = (event) => {
    const { value } = event.target;
    if (value === `${window.location.origin}/share/${info?.code}`) {
      setCode(info?.code);
    } else if (value === "" || alphabetAndNumberNoSpace.test(value)) {
      setCode(value);
    }
  };

  const onRedeemCode = () => {
    if (!code) return;
    dispatch(post_redeem_code(code));
  };

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    }
  }, [isCopied]);

  return (
    <div className="share-modal">
      <h4 className="sub-title">
        {t(!is_share_finished ? "FFIP_SHARE_LINK" : "FFIP_REDEEM_CODE")}
      </h4>
      <div className="referral">
        <span className={`copied-text ${isCopied ? "fade-in" : "fade-out"}`}>
          {t("FFIP_LINK_COPIED")}
        </span>
        {!is_share_finished && (
          <div className="referral__link">
            <input
              type="text"
              readOnly
              value={info?.code}
            />
            <CopyToClipboard
              text={`${window.location.origin}/share/${info?.code}`}
            >
              <button
                className="btn btn-share"
                style={btnShareBg}
                onClick={() => setIsCopied(true)}
              >
                {t("FFIP_COPY_URL")}
              </button>
            </CopyToClipboard>
          </div>
        )}
        <div className="referral__redeem">
          <input
            className="redeem-input"
            type="text"
            value={code}
            onChange={handleRedeemInput}
          />
          <button
            className="btn btn-redeem"
            style={useBackgroundAssets("btn_share")}
            onClick={onRedeemCode}
          >
            {t("FFIP_REDEEM_CODE")}
          </button>
        </div>
      </div>
      <button
        className="btn btn-close uppercase"
        style={useBackgroundAssets("btn_spin_to_get")}
        onClick={() => dispatch(toggle_popup(false, ""))}
      >
        {t("FFIP_BTN_CONTINUE")}
      </button>
    </div>
  );
};
